// removed by extract-text-webpack-plugin
module.exports = {"refund-policy-description":"refund-policy-modal__refund-policy-description__3e9hg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/refund-policy-modal.scss
// module id = 1396
// module chunks = 1